import React from "react";
import { useTranslation } from "react-i18next";
import Button, { ButtonProps } from "@mui/material/Button";

interface Props {
  children?: React.ReactNode;
}

export function CancelButton(props: Props & ButtonProps) {
  const { children, ...rest } = props;
  const { t } = useTranslation();
  return (
    <Button variant="contained" type={"button"} color="secondary" {...rest}>
      {children ?? t("common.cancel")}
    </Button>
  );
}
